import { useContext } from 'react';
import { createContextHook } from '@/utils';
import { JobContext } from './JobContext';

export const useJobContext = createContextHook(JobContext);

// For consumers that render both inside and outside a JobContextProvider
// (e.g. shared export forms mounted on published pages).
export const useOptionalJobContext = () => useContext(JobContext);
